const assert = require('assert');
const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class BookingHistoryConnector {
  constructor(configuration, tokenManager) {
    assert(configuration, 'configuration is required');
    this.httpClient = axios.create(configuration);

    this.tokenManager = tokenManager;
  }

  /**
   * Get the booking history details for the given bookingId and bookingChannelId.
   * This method is only allowed for API clients making requests through the INTERNAL Api Domain.
   * @param bookingId
   * @param bookingChannelId
   * @returns {Promise<void|*>}
   */
  async getById({ bookingId, bookingChannelId }) {
    assert(bookingId, 'bookingId is required');
    assert(bookingChannelId, 'bookingChannelId is required');
    try {
      const options = await this.getOptions();
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/history/details/${bookingId}?bookingChannelId=${bookingChannelId}`, options);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getOptions() {
    if (!this.tokenManager) {
      return {};
    }

    const token = await this.tokenManager.getToken();
    return {
      headers: {
        Authorization: `Bearer ${token.accessToken}`,
      },
    };
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  BookingHistoryConnector,
};
